/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorPostCounselingRequestExaminerTypename =
  "PharmacyCounselorPostCounselingRequestExaminer" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPostCounselingRequestExaminer
 */
export interface PharmacyCounselorPostCounselingRequestExaminer {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPostCounselingRequestExaminer
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPostCounselingRequestExaminer
   */
  gender?: PharmacyCounselorPostCounselingRequestExaminerGenderEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPostCounselingRequestExaminer
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorPostCounselingRequestExaminerGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
}

export function PharmacyCounselorPostCounselingRequestExaminerFromJSON(
  json: any
): PharmacyCounselorPostCounselingRequestExaminer {
  return PharmacyCounselorPostCounselingRequestExaminerFromJSONTyped(json, false);
}

export function PharmacyCounselorPostCounselingRequestExaminerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPostCounselingRequestExaminer {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPostCounselingRequestExaminerTypename,

    dateOfBirth: !exists(json, "date_of_birth") ? undefined : json["date_of_birth"],
    gender: !exists(json, "gender") ? undefined : json["gender"],
  };
}

export function PharmacyCounselorPostCounselingRequestExaminerToJSON(
  object?: PharmacyCounselorPostCounselingRequestExaminer | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    gender: value.gender,
  };
}
